// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"bn-z","hideOnMobile":"cn-z"};